export const MEMORAMA_API_URL = 'https://connector.dynamicore.io/connector/3018/cbdfbc610c12414c88f187f288404c97';
export const MEMORAMA_RECORDS_API_URL = 'https://connector.dynamicore.io/connector/3018/f8e47cb71d264c6ca1e590b7fe6dd68d';

export const registerMemoramaParticipant = async ({ fullName, email, phone, company, pairs, prize }) => {
  const response = await fetch(MEMORAMA_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      full_name: fullName,
      email,
      phone,
      company,
      game: 'memorama',
      extras: { aciertos: pairs, premio: prize },
    }),
  });

  if (!response.ok) throw new Error(`Memorama registration failed with status ${response.status}`);
  return response.json().catch(() => null);
};

const extractRecords = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  return payload.data || payload.records || payload.results || payload.items || [];
};

export const getMemoramaParticipants = async () => {
  const response = await fetch(MEMORAMA_RECORDS_API_URL, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`Memorama records request failed with status ${response.status}`);
  return extractRecords(await response.json());
};
